import { defineStore } from "pinia";
import {
  IDataProviderData,
  IDataProviderRequest,
  IDataProviderTableDefinition,
} from "@/interfaces/data-provider";
import { $http } from "@/main";
import config from "@/util/constants";
import { AxiosResponse } from "axios";
import { defaults } from "lodash";

interface CatalogState {
  selectedCatalog: string;
  catalogList: string[];
  tableMeta: IDataProviderTableDefinition | null;
  tableData: IDataProviderData | null;
  selectedDataCatId: any;
  currentItems: Array<any>;
  currentFields: Array<string>;
}
export const useCatalog = defineStore("catalog", {
  state: (): CatalogState => ({
    selectedCatalog: "",
    catalogList: [],
    tableMeta: null,
    tableData: null,
    selectedDataCatId: 0,
    currentItems: [],
    currentFields: [],
  }),
  actions: {
    async getCatalogs() {
      this.catalogList = await $http
        .get(config.urls.catalogue.listCatalogs)
        .then(({ data }) => data);
    },
    async getTableMeta(payload: {
      catalogUri: string;
      request: Partial<IDataProviderRequest>;
      updateState?: boolean;
    }) {
      const args = defaults(payload, { updateState: true });
      const tableMeta = await $http
        .post<
          IDataProviderRequest,
          AxiosResponse<{ dataSetDefinition: IDataProviderTableDefinition }>
        >(`${config.urls.data.getData}${args.catalogUri}/meta`, args.request)
        .then(({ data }) => data.dataSetDefinition);
      if (args.updateState) {
        this.tableMeta = tableMeta;
      }
      return tableMeta;
    },
    async getTableData(payload: {
      catalogUri: string;
      request: Partial<IDataProviderRequest>;
      updateState?: boolean;
    }) {
      const args = defaults(payload, { updateState: true });
      const tableData = await $http
        .post<IDataProviderRequest, AxiosResponse<{ data: IDataProviderData }>>(
          `${config.urls.data.getData}${args.catalogUri}/data`,
          args.request
        )
        .then(({ data }) => data.data);
      if (args.updateState) {
        this.tableData = tableData;
      }
      return tableData;
    },
    async setSelectedDataCatId(dataCatId: number) {
      this.selectedDataCatId = dataCatId;
    },
    async setCurrentItems(items: Array<any>) {
      this.currentItems = items;
    },
    async setCurrentFields(fields: Array<string>) {
      this.currentFields = fields;
    },
    async setSelectedCatalog(catalogUri: string) {
      this.selectedCatalog = catalogUri;
    },
  },
});
